const PERCENT_SUFFIX = '%';

/** The single spelling of a level reading, shared by the gauges and the indicators. */
export function formatPercent(percent: number) {
  return `${percent} ${PERCENT_SUFFIX}`;
}
